import { SVGIconComponent } from './types';

export const Send: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Action/Send" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M4.58215504,13.8037196 L10.8025576,16.1975681 L13.1964314,22.4179048 C13.3310289,22.7535224 13.6666591,23 14.024118,23 C14.3824719,23 14.718093,22.7762549 14.8518045,22.4406373 L20.9375111,7.22597251 C21.0721086,6.89035491 20.982086,6.51016728 20.7364874,6.26368971 C20.4900073,6.01721214 20.1098156,5.92807211 19.7741944,6.06266819 L4.5593686,12.1483104 C4.22374744,12.2829065 4,12.618533 4,12.9759881 C4,13.3561758 4.22374744,13.6699558 4.58210134,13.8036659 L4.58215504,13.8037196 Z M18.499022,8.50118517 L14.0460005,19.6439134 L12.6143749,15.9075945 L14.963723,13.5582713 L13.6885416,12.2831034 L11.4510672,14.5205541 L7.35626528,12.9543386 L18.499022,8.50118517 Z"
        id="icon-resend"
        fill="#848484"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
